import React from "react";

import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import {
	BrowserRouter,
	createRoutesFromChildren,
	matchRoutes,
	Route,
	Routes,
	useLocation,
	useNavigationType,
} from "react-router";

import "./index.css";

import { store } from "./redux/store";
import "./i18n/config";


import Layout from "./components/layout";
import AccidentsData from "./pages/accidents/accidents.data";
import AccidentsDetails from "./pages/accidents/accidents.details";
import AccidentsForm from "./pages/accidents/accidents.form";
import LogIn from "./pages/login";
import NotFound from "./pages/notFound";
import Settings from "./pages/settings";

Sentry.init({
	dsn: "https://d5d9bf8e58173f9fa02c048c654e5f8e@o4506070216343552.ingest.us.sentry.io/4506971768225792",
	enabled: process.env.NODE_ENV === "production",
	integrations: [
		Sentry.reactRouterV6BrowserTracingIntegration({
			useEffect: React.useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes,
		}),
	],
	tracesSampleRate: 0.4,
	tracePropagationTargets: ["localhost", /^https:\/\/api\.acna\.cat\/api/],
	replaysSessionSampleRate: 0,
	replaysOnErrorSampleRate: 1.0,
});

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<Provider store={store}>
				<BrowserRouter>
					<Routes>
						<Route
							index
							element={
								<Layout>
									<AccidentsData />
								</Layout>
							}
						/>
						<Route path="login" element={<LogIn />} />
						<Route
							path="settings"
							element={
								<Layout>
									<Settings />
								</Layout>
							}
						/>
						<Route path="accidents">
							<Route path="add" element={<AccidentsForm />} />
							<Route path=":accident_id" element={<AccidentsDetails />}>
								<Route path="edit" element={<AccidentsForm edit />} />
							</Route>
						</Route>
						<Route path="*" element={<NotFound />} />
					</Routes>
				</BrowserRouter>
			</Provider>
		</QueryClientProvider>
	</React.StrictMode>,
);
